import { createSlice } from "@reduxjs/toolkit";
import { LAYOUTS, PREVIEW_INITIAL } from "../../constants/general";

export const initialSlideState = {
  canvasData: [],
  scriptData: null,
  previewURL: PREVIEW_INITIAL,
};

export const initialState = {
  slides: [initialSlideState],
  currentSlideIndex: 0,
  currentSlide: { ...initialSlideState },
  canvasData: [],
  reload: false,
  canvasDimensions: { width: 100, height: 100 },
  loaderValue: 0,
  uploadMessage: "Uploading slide data. Please wait until it reaches 100%",
  generateLoading: false,
  layout: LAYOUTS.LANDSCAPE,
  width: 1920,
  height: 1080,
  // canvasDimensions: {
  //   width: 0,
  //   height: 0,
  // },
};

/**
 * NOTE
 * Please do not use slide methods of this slice.
 * for that use slideSlice as slidesSlice is used to generate video.
 *
 * just define canvas level info. ex: dimension,etc.
 */
export const canvasSlice = createSlice({
  name: "canvas",
  initialState,
  reducers: {
    setCurrentSlideIndex: (state, action) => {
      state.currentSlideIndex = action.payload;
    },
    setCurrentSlide: (state, action) => {
      state.currentSlide = action.payload;
    },
    addSlide: (state, action) => {
      state.slides.push({ ...initialSlideState, ...action.payload });
    },
    addObject: (state, action) => {
      const index = state.canvasData.findIndex(
        (obj) => obj.id === action.payload.id
      );
      if (index !== -1) {
        // Replace the existing object
        state.canvasData[index] = action.payload;
      } else {
        // Add the new object
        state.canvasData.push(action.payload);
      }
    },
    updateObject: (state, action) => {
      const index = state.canvasData.findIndex(
        (obj) => obj.id === action.payload.id
      );
      state.canvasData[index] = action.payload.newObject;
    },
    removeObject: (state, action) => {
      const index = state.canvasData.findIndex(
        (obj) => obj.id === action.payload.id
      );
      state.canvasData[index] = state.canvasData.splice(index, 1);
    },
    finishReload: (state) => {
      state.reload = false;
    },
    setCanvasData: (state, action) => {
      state.canvasData = action.payload;
      state.reload = true;
    },
    // setCanvasDimensions: (state, action) => {
    //   state.canvasDimensions = action.payload;
    // },
    updateSlides: (state, action) => {
      state.slides = action.payload;
    },
    setLoaderValue: (state, action) => {
      state.loaderValue = action.payload;
    },
    setGenerateLoading: (state, action) => {
      state.generateLoading = action.payload;
    },
    setUploadMessage: (state, action) => {
      state.uploadMessage = action.payload;
    },
    setHeight: (state, action) => {
      state.height = action.payload;
    },
    setWidth: (state, action) => {
      state.width = action.payload;
    },
    setLayout: (state, action) => {
      state.layout = action.payload;
    },
    setCanvasDimensions: (state, action) => {
      state.canvasDimensions = action.payload;
      // return state;
    },
    resetSlide: (state) => {
      state.slides[state.currentSlide] = initialSlideState;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const {
  finishReload,
  setCanvasDimensions,
  setLoaderValue,
  setUploadMessage,
  setGenerateLoading,
  setLayout,
  setWidth,
  setHeight,
} = canvasSlice.actions;

export const getCanvasState = (state) => {
  const canvas = { ...state.canvas };
  const slides = [...state.canvas.slides];
  const currentSlideIndex = state.canvas.currentSlideIndex;
  const currentSlide = { ...state.canvas.currentSlide };

  return { canvas, currentSlide, currentSlideIndex, slides };
};

export default canvasSlice.reducer;
